(function () {
  'use strict';

  var EQUIPMENT = [
    { id: 'all', label: 'All Videos', icon: 'tcb-menu-icon-guide-book.svg' },
    { id: 'floor-scrubbers', label: 'Floor Scrubbers', icon: 'tcb-menu-icon-walk-behind-scrubber.svg' },
    { id: 'sweepers', label: 'Sweepers', icon: 'tcb-menu-icon-walk-behind-sweeper.svg' },
    { id: 'vacuums', label: 'Vacuums', icon: 'tcb-menu-icon-upright-vacuum.svg' },
    { id: 'carpet-cleaners', label: 'Carpet Cleaners', icon: 'tcb-menu-icon-canister-extractor.svg' },
    { id: 'pressure-washers', label: 'Pressure Washers', icon: 'tcb-menu-icon-industrial-spray.svg' },
    { id: 'steam-cleaners', label: 'Steam Cleaners', icon: 'tcb-menu-icon-industrial-spray.svg' },
    { id: 'parts-maintenance', label: 'Parts & Maintenance', icon: 'tcb-menu-icon-maintenance.svg' },
    { id: 'troubleshooting', label: 'Troubleshooting', icon: 'tcb-menu-icon-service-repair.svg' },
    { id: 'safety', label: 'Safety', icon: 'tcb-menu-icon-warranty-shield.svg' },
    { id: 'product-overviews', label: 'Product Overviews', icon: 'tcb-menu-icon-quality-shield.svg' }
  ];

  var TYPES = [
    { id: 'how-to', label: 'How-To' },
    { id: 'maintenance', label: 'Maintenance' },
    { id: 'troubleshooting', label: 'Troubleshooting' },
    { id: 'product-overview', label: 'Product Overview' },
    { id: 'safety', label: 'Safety' }
  ];

  var TOPICS = [
    { id: 'getting-started', label: 'Getting Started', filter: 'how-to setup unbox starter' },
    { id: 'maintenance-care', label: 'Maintenance & Care', filter: 'maintenance battery charger pad' },
    { id: 'parts-replacement', label: 'Parts Replacement', filter: 'squeegee blade parts replacement' },
    { id: 'troubleshooting', label: 'Troubleshooting', filter: 'troubleshooting diagnose streak' },
    { id: 'safety-best-practices', label: 'Safety & Best Practices', filter: 'safety manual guidelines' },
    { id: 'product-overviews', label: 'Product Overviews', filter: 'buying comparison overview choose' }
  ];

  var PAGE_SIZE = 8;

  function norm(s) {
    return (s || '').toLowerCase().trim();
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function youtubeId(url) {
    if (!url) return '';
    if (url.indexOf('youtu.be/') !== -1) return url.split('youtu.be/')[1].split(/[?&]/)[0];
    if (url.indexOf('watch?v=') !== -1) return url.split('v=')[1].split('&')[0];
    if (url.indexOf('/embed/') !== -1) return url.split('/embed/')[1].split(/[?&]/)[0];
    if (url.indexOf('/shorts/') !== -1) return url.split('/shorts/')[1].split(/[?&]/)[0];
    return '';
  }

  function makeAssetUrl(root, path) {
    if (!path) return '';
    if (path.indexOf('http') === 0 || path.indexOf('//') === 0) return path;
    var base = (root && root.getAttribute('data-icon-base')) || '/cdn/shop/t/1/assets/';
    return base + path;
  }

  function videoHaystack(video) {
    return [
      video.title,
      video.subtitle,
      video.description,
      video.category,
      video.equipment,
      video.type,
      video.keywords,
      video.topics && video.topics.join(' ')
    ]
      .join(' ');
  }

  function posterFor(video) {
    var yt = youtubeId(video.youtube_url);
    if (video.thumbnail) return video.thumbnail;
    if (yt) return 'https://i.ytimg.com/vi/' + yt + '/hqdefault.jpg';
    return '';
  }

  function videoUrl(id) {
    var base = window.location.pathname;
    return base + '?v=' + encodeURIComponent(id);
  }

  function buildThumb(video, className, linkDetail) {
    var yt = youtubeId(video.youtube_url);
    var poster = posterFor(video);
    var href = linkDetail ? videoUrl(video.id) : '#';
    var tag = linkDetail ? 'a' : 'div';
    var attrs = linkDetail ? ' href="' + escapeHtml(href) + '" data-vlib-open="' + escapeHtml(video.id) + '"' : '';
    var media = '';

    if (poster) {
      media += '<img class="' + className + '__poster" src="' + escapeHtml(poster) + '" alt="" width="640" height="360" loading="lazy">';
    } else {
      media += '<div class="' + className + '__poster ' + className + '__poster--placeholder" aria-hidden="true"></div>';
    }

    media +=
      '<span class="' +
      className +
      '__play" aria-hidden="true"><span class="' +
      className +
      '__play-icon"></span></span>';

    if (video.duration) {
      media += '<span class="' + className + '__duration">' + escapeHtml(video.duration) + '</span>';
    }

    return (
      '<' +
      tag +
      ' class="' +
      className +
      '__media"' +
      attrs +
      '>' +
      media +
      '</' +
      tag +
      '>'
    );
  }

  function buildFeaturedCard(video) {
    return (
      '<article class="tcb-vlib-fcard">' +
      buildThumb(video, 'tcb-vlib-fcard', true) +
      '<div class="tcb-vlib-fcard__body">' +
      (video.category ? '<span class="tcb-vlib-fcard__tag">' + escapeHtml(video.category) + '</span>' : '') +
      '<h3 class="tcb-vlib-fcard__title"><a href="' +
      escapeHtml(videoUrl(video.id)) +
      '" data-vlib-open="' +
      escapeHtml(video.id) +
      '">' +
      escapeHtml(video.title) +
      '</a></h3>' +
      (video.description ? '<p class="tcb-vlib-fcard__desc">' + escapeHtml(video.description) + '</p>' : '') +
      '</div></article>'
    );
  }

  function buildListRow(video) {
    var tags = [];
    if (video.category) tags.push(video.category);
    if (video.type) {
      var typeLabel = (TYPES.find(function (t) { return t.id === video.type; }) || {}).label || video.type;
      tags.push(typeLabel);
    }

    return (
      '<article class="tcb-vlib-row">' +
      buildThumb(video, 'tcb-vlib-row', true) +
      '<div class="tcb-vlib-row__body">' +
      '<h3 class="tcb-vlib-row__title"><a href="' +
      escapeHtml(videoUrl(video.id)) +
      '" data-vlib-open="' +
      escapeHtml(video.id) +
      '">' +
      escapeHtml(video.title) +
      '</a></h3>' +
      (video.description ? '<p class="tcb-vlib-row__desc">' + escapeHtml(video.description) + '</p>' : '') +
      (tags.length
        ? '<div class="tcb-vlib-row__tags">' +
          tags
            .map(function (tag) {
              return '<span>' + escapeHtml(tag) + '</span>';
            })
            .join('') +
          '</div>'
        : '') +
      '<a class="tcb-vlib-row__watch" href="' +
      escapeHtml(videoUrl(video.id)) +
      '" data-vlib-open="' +
      escapeHtml(video.id) +
      '">Watch video <span aria-hidden="true">→</span></a>' +
      '</div></article>'
    );
  }

  function buildPlayer(video) {
    var yt = youtubeId(video.youtube_url);
    var poster = posterFor(video);
    if (!yt) {
      return (
        '<div class="tcb-vlib-player tcb-vlib-player--placeholder">' +
        (poster ? '<img src="' + escapeHtml(poster) + '" alt="" width="1280" height="720">' : '') +
        '<div class="tcb-vlib-player__overlay">' +
        '<p>Video walkthrough coming soon.</p>' +
        (video.guide_url
          ? '<a class="tcb-rh-btn tcb-rh-btn--blue" href="' + escapeHtml(video.guide_url) + '">Read the full guide</a>'
          : '') +
        '</div></div>'
      );
    }

    return (
      '<div class="tcb-vlib-player" data-tcb-lazy-video>' +
      (poster ? '<img class="tcb-vid-card__poster" src="' + escapeHtml(poster) + '" alt="" width="1280" height="720">' : '<div class="tcb-vid-card__poster tcb-vid-card__poster--placeholder"></div>') +
      '<button type="button" class="tcb-vid-card__play" aria-label="Play ' +
      escapeHtml(video.title) +
      '"><span class="tcb-vid-card__play-icon" aria-hidden="true"></span></button>' +
      '<iframe class="tcb-vid-card__iframe" title="' +
      escapeHtml(video.title) +
      '" data-src="https://www.youtube.com/embed/' +
      escapeHtml(yt) +
      '?autoplay=1&rel=0&modestbranding=1&playsinline=1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen loading="lazy"></iframe>' +
      '</div>'
    );
  }

  function buildDetail(video, allVideos, contactUrl) {
    var related = (video.related_ids || [])
      .map(function (id) {
        return allVideos.find(function (v) { return v.id === id; });
      })
      .filter(Boolean)
      .slice(0, 5);

    var quick = [
      { label: 'Video Length', value: video.duration || '—' },
      { label: 'Skill Level', value: video.skill_level || 'All levels' },
      { label: 'Category', value: video.category || '—' },
      { label: 'Topics Covered', value: (video.topics || []).join(', ') || '—' }
    ];

    var learn = video.learn || [];
    var steps = video.steps || [];

    return (
      '<div class="tcb-wrap">' +
      '<nav class="tcb-rh__crumb tcb-vlib-detail__crumb" aria-label="Breadcrumb">' +
      '<a href="/">Home</a> <span aria-hidden="true">›</span> ' +
      '<a href="/pages/video-library" data-vlib-back>Video Library</a> <span aria-hidden="true">›</span> ' +
      (video.category ? '<span>' + escapeHtml(video.category) + '</span> <span aria-hidden="true">›</span> ' : '') +
      '<span aria-current="page">' + escapeHtml(video.title) + '</span>' +
      '</nav>' +
      '<div class="tcb-vlib-detail__layout">' +
      '<main class="tcb-vlib-detail__main">' +
      (video.category ? '<span class="tcb-vlib-detail__tag">' + escapeHtml(video.category) + '</span>' : '') +
      '<h1>' + escapeHtml(video.title) + '</h1>' +
      (video.subtitle ? '<p class="tcb-vlib-detail__subtitle">' + escapeHtml(video.subtitle) + '</p>' : '') +
      buildPlayer(video) +
      '<div class="tcb-vlib-quickbar">' +
      quick
        .map(function (item) {
          return '<div class="tcb-vlib-quickbar__item"><strong>' + escapeHtml(item.label) + '</strong><span>' + escapeHtml(item.value) + '</span></div>';
        })
        .join('') +
      '</div>' +
      (video.intro ? '<p class="tcb-vlib-detail__intro">' + escapeHtml(video.intro) + '</p>' : video.description ? '<p class="tcb-vlib-detail__intro">' + escapeHtml(video.description) + '</p>' : '') +
      (learn.length
        ? '<section class="tcb-vlib-learn"><div class="tcb-vlib-learn__grid">' +
          '<div><h2>What You\'ll Learn in This Video</h2><ul class="tcb-benefit-checks tcb-benefit-checks--stack">' +
          learn
            .map(function (item) {
              return '<li><svg class="tcb-benefit-checks__icon" width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><circle cx="9" cy="9" r="8" fill="rgba(47,139,255,.15)"/><path d="M5.5 9.2l2.1 2.1 5-5" fill="none" stroke="#2f8bff" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>' + escapeHtml(item) + '</li>';
            })
            .join('') +
          '</ul></div>' +
          (video.pro_tip
            ? '<aside class="tcb-vlib-protip"><strong>Pro Tip</strong><p>' + escapeHtml(video.pro_tip) + '</p></aside>'
            : '') +
          '</div></section>'
        : '') +
      (steps.length
        ? '<section class="tcb-rh-steps"><h3>Step-by-Step Overview</h3><div class="tcb-rh-steps__grid">' +
          steps
            .map(function (step, i) {
              return (
                '<div class="tcb-rh-steps__item"><span class="tcb-rh-steps__num">' +
                (i + 1) +
                '</span><div><strong>' +
                escapeHtml(step.title) +
                '</strong><p>' +
                escapeHtml(step.text) +
                '</p></div></div>'
              );
            })
            .join('') +
          '</div></section>'
        : '') +
      '<section class="tcb-vlib-resources"><h2>More Resources</h2><div class="tcb-bf-help-grid">' +
      (video.guide_url
        ? '<a class="tcb-bf-help-card" href="' + escapeHtml(video.guide_url) + '"><div><strong>Read Full Guide</strong><span>Written walkthrough with photos and links.</span></div><svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></a>'
        : '') +
      '<a class="tcb-bf-help-card" href="/pages/parts-maintenance"><div><strong>Maintenance Guides</strong><span>Parts replacement and care schedules.</span></div><svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></a>' +
      '<a class="tcb-bf-help-card" href="/pages/buying-guides"><div><strong>Buying Guides</strong><span>Compare machines before you buy.</span></div><svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></a>' +
      '<a class="tcb-bf-help-card" href="/collections/parts"><div><strong>Parts & Accessories</strong><span>Shop blades, pads, batteries, and more.</span></div><svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></a>' +
      '</div></section>' +
      '</main>' +
      '<aside class="tcb-vlib-detail__aside" aria-label="Video details">' +
      '<div class="tcb-vlib-aside-card"><h3>About This Video</h3><dl class="tcb-vlib-meta">' +
      (video.equipment_type ? '<div><dt>Equipment Type</dt><dd>' + escapeHtml(video.equipment_type) + '</dd></div>' : '') +
      (video.applies_to ? '<div><dt>Applies To</dt><dd>' + escapeHtml(video.applies_to) + '</dd></div>' : '') +
      (video.duration ? '<div><dt>Video Length</dt><dd>' + escapeHtml(video.duration) + '</dd></div>' : '') +
      (video.skill_level ? '<div><dt>Skill Level</dt><dd>' + escapeHtml(video.skill_level) + '</dd></div>' : '') +
      '</dl>' +
      (video.guide_url
        ? '<a class="tcb-rh-btn tcb-rh-btn--ghost" href="' + escapeHtml(video.guide_url) + '">Download video transcript</a>'
        : '') +
      '</div>' +
      '<div class="tcb-vlib-aside-card"><div class="tcb-rh-section__head"><h3>Related Videos</h3><a href="/pages/video-library" data-vlib-back>View all videos →</a></div><ul class="tcb-vlib-aside-list">' +
      (related.length
        ? related
            .map(function (rel) {
              return (
                '<li><a href="' +
                escapeHtml(videoUrl(rel.id)) +
                '" data-vlib-open="' +
                escapeHtml(rel.id) +
                '"><span class="tcb-vlib-aside-list__thumb">' +
                (posterFor(rel)
                  ? '<img src="' + escapeHtml(posterFor(rel)) + '" alt="" width="80" height="45" loading="lazy">'
                  : '<span class="tcb-vlib-aside-list__placeholder"></span>') +
                '<span class="tcb-vlib-aside-list__play" aria-hidden="true"></span></span><span><strong>' +
                escapeHtml(rel.title) +
                '</strong><em>' +
                escapeHtml(rel.duration || '') +
                '</em></span></a></li>'
              );
            })
            .join('')
        : '<li><a href="/pages/video-library" data-vlib-back>Browse the video library</a></li>') +
      '</ul></div>' +
      '<div class="tcb-vlib-aside-card"><h3>Helpful Links</h3><ul class="tcb-vlib-aside-links">' +
      '<li><a href="/collections/all?q=floor+scrubber">Shop Floor Scrubbers →</a></li>' +
      '<li><a href="/collections/parts">Parts & Supplies →</a></li>' +
      '<li><a href="/pages/parts-maintenance">Maintenance Guides →</a></li>' +
      '<li><a href="/pages/cleaning-tips">Cleaning Tips →</a></li>' +
      '<li><a href="/pages/equipment-finder-quiz">Equipment Finder →</a></li>' +
      '</ul></div>' +
      '<div class="tcb-vlib-aside-card tcb-vlib-aside-card--help"><h3>Need Help?</h3><p>Call <a href="tel:+18559085666">(855) 908-5666</a><br>Mon–Fri 8am–6pm ET</p><a class="tcb-rh-btn tcb-rh-btn--green" href="' +
      escapeHtml(contactUrl) +
      '">Contact an Expert</a></div>' +
      '</aside></div></div>'
    );
  }

  function countByEquipment(videos) {
    var counts = { all: videos.length };
    videos.forEach(function (video) {
      var key = video.equipment || 'product-overviews';
      counts[key] = (counts[key] || 0) + 1;
    });
    return counts;
  }

  function countByType(videos) {
    var counts = {};
    videos.forEach(function (video) {
      if (!video.type) return;
      counts[video.type] = (counts[video.type] || 0) + 1;
    });
    return counts;
  }

  function init(root) {
    var jsonUrl = root.getAttribute('data-json-url');
    if (!jsonUrl) return;

    var contactUrl = root.getAttribute('data-contact-url') || '/pages/contact?topic=equipment#tcb-contact-form';
    var hubEl = root.querySelector('[data-tcb-vlib-hub]');
    var detailEl = root.querySelector('[data-tcb-vlib-detail]');
    var leftAside = root.querySelector('[data-tcb-vlib-sidebar-left]');
    var rightAside = root.querySelector('[data-tcb-vlib-sidebar-right]');
    var featuredSection = root.querySelector('[data-tcb-vlib-featured]');
    var featuredGrid = root.querySelector('[data-tcb-vlib-featured-grid]');
    var listEl = root.querySelector('[data-tcb-vlib-list]');
    var countEl = root.querySelector('[data-tcb-vlib-count]');
    var searchInput = root.querySelector('[data-tcb-vlib-search]');
    var emptyEl = root.querySelector('[data-tcb-vlib-empty]');
    var loadMoreBtn = root.querySelector('[data-tcb-vlib-load-more]');
    var showAllFeaturedBtn = root.querySelector('[data-vlib-show-all]');

    var videos = [];
    var activeEquipment = 'all';
    var activeTypes = {};
    var activeTopic = '';
    var listLimit = PAGE_SIZE;
    var detailId = new URLSearchParams(window.location.search).get('v');
    var featuredOnly = false;

    function matches(video) {
      if (featuredOnly && !video.featured) return false;
      var q = norm(searchInput ? searchInput.value : '');
      if (activeEquipment !== 'all' && video.equipment !== activeEquipment) return false;

      var typeKeys = Object.keys(activeTypes).filter(function (k) { return activeTypes[k]; });
      if (typeKeys.length && typeKeys.indexOf(video.type) === -1) return false;

      if (activeTopic) {
        var topic = TOPICS.find(function (t) { return t.id === activeTopic; });
        if (topic && norm(videoHaystack(video)).indexOf(norm(topic.filter)) === -1) return false;
      }

      if (!q) return true;
      return norm(videoHaystack(video)).indexOf(q) !== -1;
    }

    function filteredVideos() {
      return videos.filter(matches);
    }

    function paintSidebars() {
      var eqCounts = countByEquipment(videos);
      var typeCounts = countByType(videos);

      if (leftAside) {
        leftAside.innerHTML =
          '<div class="tcb-vlib-sidebar__card"><h3>Browse by Category</h3><ul class="tcb-vlib-cats">' +
          EQUIPMENT.map(function (eq) {
            var count = eqCounts[eq.id] || 0;
            if (eq.id !== 'all' && !count) return '';
            var active = activeEquipment === eq.id ? ' is-active' : '';
            return (
              '<li><button type="button" class="tcb-vlib-cats__btn' +
              active +
              '" data-vlib-equipment="' +
              escapeHtml(eq.id) +
              '"><img src="' +
              escapeHtml(makeAssetUrl(root, eq.icon)) +
              '" alt="" width="18" height="18" loading="lazy"><span>' +
              escapeHtml(eq.label) +
              '</span><em>' +
              (eq.id === 'all' ? eqCounts.all + '+' : count) +
              '</em></button></li>'
            );
          }).join('') +
          '</ul></div>' +
          '<div class="tcb-vlib-sidebar__card"><h3>Filter by Type</h3><ul class="tcb-vlib-types">' +
          TYPES.map(function (type) {
            var count = typeCounts[type.id] || 0;
            if (!count) return '';
            var checked = activeTypes[type.id] ? ' checked' : '';
            return (
              '<li><label class="tcb-vlib-types__label"><input type="checkbox" data-vlib-type="' +
              escapeHtml(type.id) +
              '"' +
              checked +
              '><span>' +
              escapeHtml(type.label) +
              '</span><em>' +
              count +
              '</em></label></li>'
            );
          }).join('') +
          '</ul></div>' +
          '<div class="tcb-vlib-sidebar__card tcb-vlib-sidebar__card--cta"><h3>Can\'t find the video you need?</h3><p>Our equipment experts can point you to the right guide or walk you through setup.</p><a class="tcb-rh-btn tcb-rh-btn--blue" href="' +
          escapeHtml(contactUrl) +
          '">Contact Support</a></div>';
      }

      var popular = videos
        .slice()
        .sort(function (a, b) {
          return (a.popular_rank || 99) - (b.popular_rank || 99);
        })
        .slice(0, 4);

      if (rightAside) {
        rightAside.innerHTML =
          '<div class="tcb-vlib-sidebar__card"><div class="tcb-rh-section__head"><h3>Popular Videos</h3><a href="#tcb-vlib-all-videos">View all →</a></div><ul class="tcb-vlib-pop-list">' +
          popular
            .map(function (video) {
              return (
                '<li><a href="' +
                escapeHtml(videoUrl(video.id)) +
                '" data-vlib-open="' +
                escapeHtml(video.id) +
                '"><span class="tcb-vlib-aside-list__thumb">' +
                (posterFor(video)
                  ? '<img src="' + escapeHtml(posterFor(video)) + '" alt="" width="80" height="45" loading="lazy">'
                  : '<span class="tcb-vlib-aside-list__placeholder"></span>') +
                '</span><span><strong>' +
                escapeHtml(video.title) +
                '</strong><em>' +
                escapeHtml(video.duration || '') +
                '</em></span></a></li>'
              );
            })
            .join('') +
          '</ul></div>' +
          '<div class="tcb-vlib-sidebar__card"><div class="tcb-rh-section__head"><h3>Video Topics</h3><a href="#tcb-vlib-all-videos">View all topics →</a></div><ul class="tcb-vlib-topic-list">' +
          TOPICS.map(function (topic) {
            var active = activeTopic === topic.id ? ' is-active' : '';
            return (
              '<li><button type="button" class="tcb-vlib-topic-list__btn' +
              active +
              '" data-vlib-topic="' +
              escapeHtml(topic.id) +
              '"><span>' +
              escapeHtml(topic.label) +
              '</span><span aria-hidden="true">→</span></button></li>'
            );
          }).join('') +
          '</ul></div>';
      }
    }

    function paintHub() {
      var filtered = filteredVideos();
      var featured = videos.filter(function (v) {
        return v.featured && matches(v);
      });

      if (featuredSection) {
        featuredSection.hidden = featured.length === 0;
        if (featuredGrid) {
          featuredGrid.innerHTML = featured.slice(0, 4).map(buildFeaturedCard).join('');
        }
      }

      if (countEl) {
        countEl.textContent = filtered.length + ' video' + (filtered.length === 1 ? '' : 's');
      }

      if (listEl) {
        listEl.innerHTML = filtered.slice(0, listLimit).map(buildListRow).join('');
      }

      if (emptyEl) emptyEl.hidden = filtered.length > 0;
      if (loadMoreBtn) loadMoreBtn.hidden = filtered.length <= listLimit;
    }

    function openDetail(id, push) {
      var video = videos.find(function (v) { return v.id === id; });
      if (!video || !detailEl) return;
      detailEl.innerHTML = buildDetail(video, videos, contactUrl);
      detailEl.hidden = false;
      if (hubEl) hubEl.hidden = true;
      document.title = video.title + ' | Video Library';
      if (push !== false) {
        var next = videoUrl(id);
        if (window.location.pathname + window.location.search !== next) {
          window.history.pushState({ vlib: id }, '', next);
        }
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      if (window.initLazyVideo) window.initLazyVideo(detailEl);
    }

    function closeDetail(push) {
      if (!detailEl) return;
      detailEl.hidden = true;
      detailEl.innerHTML = '';
      if (hubEl) hubEl.hidden = false;
      document.title = 'Video Library';
      if (push !== false) {
        window.history.pushState({ vlib: null }, '', window.location.pathname);
      }
    }

    function bindRootEvents() {
      root.addEventListener('click', function (event) {
        var open = event.target.closest('[data-vlib-open]');
        if (open) {
          event.preventDefault();
          openDetail(open.getAttribute('data-vlib-open'));
          return;
        }
        var back = event.target.closest('[data-vlib-back]');
        if (back) {
          event.preventDefault();
          closeDetail();
          return;
        }
        var eqBtn = event.target.closest('[data-vlib-equipment]');
        if (eqBtn) {
          activeEquipment = eqBtn.getAttribute('data-vlib-equipment') || 'all';
          featuredOnly = false;
          listLimit = PAGE_SIZE;
          paintSidebars();
          paintHub();
          var target = root.querySelector('#tcb-vlib-all-videos');
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        var topicBtn = event.target.closest('[data-vlib-topic]');
        if (topicBtn) {
          var nextTopic = topicBtn.getAttribute('data-vlib-topic') || '';
          activeTopic = activeTopic === nextTopic ? '' : nextTopic;
          listLimit = PAGE_SIZE;
          paintSidebars();
          paintHub();
          return;
        }
        var popular = event.target.closest('[data-vlib-popular]');
        if (popular && searchInput) {
          searchInput.value = popular.getAttribute('data-vlib-popular') || '';
          listLimit = PAGE_SIZE;
          paintHub();
        }
      });

      root.addEventListener('change', function (event) {
        var typeInput = event.target.closest('[data-vlib-type]');
        if (!typeInput) return;
        var key = typeInput.getAttribute('data-vlib-type');
        activeTypes[key] = typeInput.checked;
        listLimit = PAGE_SIZE;
        paintHub();
      });

      if (searchInput) {
        searchInput.addEventListener('input', function () {
          listLimit = PAGE_SIZE;
          paintHub();
        });
      }

      if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function () {
          listLimit += PAGE_SIZE;
          paintHub();
        });
      }

      if (showAllFeaturedBtn) {
        showAllFeaturedBtn.addEventListener('click', function () {
          activeEquipment = 'all';
          activeTopic = '';
          activeTypes = {};
          featuredOnly = true;
          if (searchInput) searchInput.value = '';
          listLimit = PAGE_SIZE;
          paintSidebars();
          paintHub();
          var target = root.querySelector('#tcb-vlib-all-videos');
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }

    window.addEventListener('popstate', function () {
      detailId = new URLSearchParams(window.location.search).get('v');
      if (detailId) openDetail(detailId, false);
      else closeDetail(false);
    });

    fetch(jsonUrl)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        videos = data.videos || [];
        bindRootEvents();
        paintSidebars();
        paintHub();
        if (detailId) openDetail(detailId, false);
      })
      .catch(function () {
        if (countEl) countEl.textContent = 'Unable to load video catalog';
      });
  }

  function boot() {
    document.querySelectorAll('[data-tcb-vlib]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
